<template lang="html">
  <div class="loading" v-show="ifLoadingStart">
    <img src="../images/common/loading_2_24x24.gif" alt="" />
     数据加载中,请稍候...
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: ['ifLoadingStart'],
}
</script>

<style lang="scss" scoped="">
  .loading {
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// loading.vue?724576dc